import { render, staticRenderFns } from "./user-agreement.html?vue&type=template&id=bf9f9fe4&scoped=true&external"
import script from "./user-agreement.js?vue&type=script&lang=js&external"
export * from "./user-agreement.js?vue&type=script&lang=js&external"
import style0 from "./user-agreement.scss?vue&type=style&index=0&id=bf9f9fe4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9f9fe4",
  null
  
)

export default component.exports